function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, computed, watch, ref, getCurrentInstance } from "vue";
import { definePropType } from "@types-vue/props";
import { GrantOrderType } from "@pt/enums/grant";
import { format, addDays } from "date-fns";
import { PartnerApproveStatus, PartnerCategory } from "@pt/enums/partner";
import { MIN_AMOUNT, RETURN_URL } from "./config";
import _ from "lodash";
import { UsageType } from "@com/enums/user";
import { getPackItems, isApprovedPartner, isMaxStorage, isPersonalGrant, isPersonalUser, transformPayload } from "./utils";
import PartnerInfo from "./partner-info.vue";
import PackTable from "./pack-table.vue";
import PackageTable from "./package-table.vue";
import { createOrder } from "@pt/api/grant";
import { privacyHref } from "@pt/views/login/utils";
import { t } from "@/lang";
import { getProfile } from "@pt/api/user";
import sendGtag from "@pt/utils/send-gtag.js";
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        orderType: {
            type: definePropType(Number),
            required: true
        },
        grant: {
            type: definePropType(Object)
        },
        plan: {
            type: definePropType(Object)
        },
        partnerInfo: {
            type: definePropType(Object),
            required: true
        },
        userInfo: {
            type: definePropType(Object),
            required: true
        }
    },
    components: {
        PartnerInfo: PartnerInfo,
        PackTable: PackTable,
        PackageTable: PackageTable
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleClose = function handleClose() {
            var _$ref;
            dialogVisible.value = false;
            (_$ref = formRef.value) === null || _$ref === void 0 ? void 0 : _$ref.resetFields();
        };
        var handleSubmit = function handleSubmit() {
            var _$ref;
            (_$ref = formRef.value) === null || _$ref === void 0 ? void 0 : _$ref.validate(function(valid) {
                if (valid) {
                    var data = transformData();
                    loading.value = true;
                    sendGtag({
                        name: "purchase_submit"
                    });
                    createOrder(data).then(function(res) {
                        if (res.data.code === 0) {
                            var _data = res.data.data, order_id = _data.order_id, pay_url = _data.pay_url;
                            handleClose();
                            setTimeout(function() {
                                window.open(pay_url.replace("{order_id}", order_id.toString()), "_blank");
                            }, 10);
                        }
                    }).catch(function(err) {
                        console.log("err", err);
                    }).finally(function() {
                        loading.value = false;
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
                return valid;
            });
        };
        var handlePackChange = function handlePackChange(val) {
            packItems.value = _.cloneDeep(val);
        };
        var transformData = function transformData() {
            var returnUrl = RETURN_URL;
            var partnerCode = userNotApproved.value ? "" : form.value.partnerCode;
            switch(props.orderType){
                case GrantOrderType.PackageBuy:
                    var _$ref;
                    var _$ref1;
                    return {
                        plan_id: (_$ref1 = (_$ref = props.grant) === null || _$ref === void 0 ? void 0 : _$ref.id) !== null && _$ref1 !== void 0 ? _$ref1 : 0,
                        return_url: returnUrl,
                        type: GrantOrderType.PackageBuy,
                        partner_code: partnerCode
                    };
                case GrantOrderType.Recharge:
                    return {
                        return_url: returnUrl,
                        type: GrantOrderType.Recharge,
                        partner_code: partnerCode,
                        amount: Number(form.value.amount)
                    };
                default:
                    return {
                        return_url: returnUrl,
                        type: GrantOrderType.PackBuy,
                        partner_code: partnerCode,
                        payload: transformPayload(packItems.value, isMaxStorage(props.userInfo.storage.total_size))
                    };
            }
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var loading = ref(false);
        var formRef = ref();
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var minAmountTip = t("playTurbo.payment.grantDialog.minAmountTip", {
            min_amount: MIN_AMOUNT
        }).toString();
        var form = ref({
            customer: "",
            agree: false,
            partnerCode: "",
            // 充值金额
            amount: ""
        });
        var userEmail = ref("");
        var userCountry = ref("");
        // 用户未准入
        var userNotApproved = computed(function() {
            return props.partnerInfo.list.length === 0;
        });
        var formRules = {
            partnerCode: [
                {
                    validator: function(rule, value, callback) {
                        // 未准入的不需要检查有没有值
                        if (userNotApproved.value) {
                            callback();
                        }
                        if (!value) {
                            callback(new Error(t("playTurbo.payment.grantDialog.partnerCodeTip").toString()));
                        } else {
                            callback();
                        }
                    }
                }, 
            ],
            agree: [
                {
                    validator: function(rule, value, callback) {
                        if (!value) {
                            callback(new Error(t("playTurbo.payment.grantDialog.agree").toString()));
                        } else {
                            callback();
                        }
                    }
                }, 
            ],
            amount: [
                {
                    validator: function(rule, value, callback) {
                        var regex = /^\d+$/;
                        if (!value) {
                            callback(new Error(t("playTurbo.payment.grantDialog.amountTips").toString()));
                        } else if (value < MIN_AMOUNT) {
                            callback(new Error(minAmountTip));
                        } else if (!regex.test(value)) {
                            callback(new Error(t("playTurbo.payment.grantDialog.amountTips2").toString()));
                        } else {
                            callback();
                        }
                    }
                }, 
            ]
        };
        var width = computed(function() {
            var w = 720;
            if (props.orderType === GrantOrderType.Recharge) {
                w = 480;
            }
            return "".concat(w, "px");
        });
        var title = computed(function() {
            switch(props.orderType){
                case GrantOrderType.PackageBuy:
                    return t("playTurbo.payment.selectPackage.contract.dialog.title");
                case GrantOrderType.Recharge:
                    return t("playTurbo.payment.grantDialog.recharge");
                case GrantOrderType.PackBuy:
                    return t("playTurbo.payment.record.grantOrderType.packBuy");
                default:
                    return "";
            }
        });
        // 有效期
        var validityDays = computed(function() {
            var _$ref, _$ref2;
            var formatString = "YYYY-MM-DD";
            var toDay = new Date();
            var start = format(toDay, formatString);
            var _$ref3, _$ref4;
            var end = props.orderType === GrantOrderType.PackBuy ? format(((_$ref3 = (_$ref = props.plan) === null || _$ref === void 0 ? void 0 : _$ref.expired_time) !== null && _$ref3 !== void 0 ? _$ref3 : 0) * 1000, formatString) : format(addDays(toDay, ((_$ref4 = (_$ref2 = props.grant) === null || _$ref2 === void 0 ? void 0 : _$ref2.validity_days) !== null && _$ref4 !== void 0 ? _$ref4 : 0) - 1), formatString);
            return "".concat(start, " \u2014 ").concat(end);
        });
        var countryList = computed(function() {
            return root.$store.state.config.countries;
        });
        if (!countryList.value.length) {
            root.$store.dispatch("config/getCountryList");
        }
        var packItems = ref(getPackItems());
        // 首次购买个人套餐时展示
        var isFirstBuy = computed(function() {
            return props.orderType === GrantOrderType.PackageBuy && props.grant && isPersonalGrant(props.grant.type) && props.partnerInfo.approve_status === PartnerApproveStatus.Unreviewed;
        });
        var approvedPartners = computed(function() {
            // 如果是个人用户，且还没有准入，就展示个人用户信息
            if (isPersonalUser(props.partnerInfo.category) && userNotApproved.value) {
                return [
                    {
                        partner_code: "",
                        category: PartnerCategory.Personal,
                        name: userEmail.value,
                        country_code: userCountry.value,
                        address: "",
                        approve_status: props.partnerInfo.approve_status
                    }, 
                ];
            }
            return props.partnerInfo.list.filter(function(partner) {
                return partner.approve_status === PartnerApproveStatus.Approved;
            });
        });
        var disabledSubmit = computed(function() {
            if (props.orderType === GrantOrderType.PackBuy) {
                return Object.values(packItems.value).filter(function(item) {
                    return item.enabled;
                }).every(function(item) {
                    return item.count === 0;
                });
            }
            return false;
        });
        function initProfile() {
            return _initProfile.apply(this, arguments);
        }
        function _initProfile() {
            _initProfile = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var res, info, _country;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return getProfile();
                        case 3:
                            res = _ctx.sent;
                            info = res.data.data;
                            userEmail.value = info.email;
                            ;
                            userCountry.value = (_country = info.country) !== null && _country !== void 0 ? _country : "";
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return _initProfile.apply(this, arguments);
        }
        watch(function() {
            return props.partnerInfo.list.length;
        }, function(val) {
            // 合作方只有一个时默认选中
            var firstPartner = approvedPartners.value[0];
            if (val === 1 && firstPartner && isApprovedPartner(firstPartner)) {
                form.value.partnerCode = firstPartner.partner_code;
            }
        }, {
            immediate: true
        });
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                initProfile();
                root.$store.dispatch("GetUserPartnerInfo");
            }
        }, {
            immediate: true
        });
        return {
            title: title,
            dialogVisible: dialogVisible,
            width: width,
            form: form,
            GrantOrderType: GrantOrderType,
            validityDays: validityDays,
            approvedPartners: approvedPartners,
            countryList: countryList,
            formRef: formRef,
            formRules: formRules,
            MIN_AMOUNT: MIN_AMOUNT,
            minAmountTip: minAmountTip,
            loading: loading,
            UsageType: UsageType,
            packItems: packItems,
            disabledSubmit: disabledSubmit,
            isFirstBuy: isFirstBuy,
            handlePackChange: handlePackChange,
            handleClose: handleClose,
            handleSubmit: handleSubmit,
            privacyHref: privacyHref
        };
    }
});
